export default __webpack_public_path__ + "static/media/lock.0a6498de.svg";